import _get from 'lodash/get';
import BaseParser from './BaseParser';
import { BaseParserOptions, ContactPointOptions } from './SharedTypes';

class ContactPoint extends BaseParser {
  private omitUse: boolean;
  /**
   * @param {Quantity} options.contactPoint - Parser used for numerator and denominator of ratio
   */
  constructor(options: BaseParserOptions = {}) {
    super();

    this.omitUse = _get<ContactPointOptions, 'omitUse', boolean>(
      options.contactPoint,
      'omitUse',
      false,
    );
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.ContactPoint) {
    if (fhirProperty === null || fhirProperty === undefined) return null;

    const { value, use } = fhirProperty;

    if (!value) {
      return null;
    }
    if (!use || this.omitUse) {
      return value;
    } else {
      return `${value} (${use})`;
    }
  }
}

export default ContactPoint;
